import { POST } from 'utils/requests.utils'

const BASE_URL = '/app/ablefy_affiliate_affiliate_clicks'

export const createItem = (data) => POST(BASE_URL, data)
